import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import ThanxLogo from 'components/Icons/ThanxLogo'
import React from 'react'

const GeneratingOverlay: React.FC = () => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="generating-overlay"
      className={css({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      })}
    >
      <div
        className={css({
          marginBottom: '16px',
          animation: 'ai-pulse 1.5s ease-in-out infinite',
        })}
      >
        <ThanxLogo
          className={css({
            width: '48px',
            height: '48px',
          })}
        />
      </div>
      <Text.Header4
        className={css({
          marginBottom: '8px',
          background:
            'linear-gradient(90deg, #0066CC 0%, #00AAFF 50%, #0066CC 100%)',
          backgroundSize: '200% 100%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: 'ai-shimmer 2s linear infinite',
        })}
      >
        Generating messages
      </Text.Header4>
      <Text.BodyText4 color="grey50">
        Customizing for your brand voice...
      </Text.BodyText4>
    </div>
  )
}

export default GeneratingOverlay
